import { DoctorRegisterStepStatus } from 'domain/entities/doctor-register'

export const doctorRegisterStepStatusTranslator: Record<
  DoctorRegisterStepStatus,
  string
> = {
  [DoctorRegisterStepStatus.PENDENT]: 'Pendente',
  [DoctorRegisterStepStatus.APPROVED_DOCTOR_REGISTER]: 'Aprovado',
  [DoctorRegisterStepStatus.REVIEW]: 'Em revisão',
  [DoctorRegisterStepStatus.EMPTY]: 'Vazio',
  [DoctorRegisterStepStatus.UNDER_ANALYSIS]: 'Em análise',
  [DoctorRegisterStepStatus.CHANGED]: 'Alterado',
  [DoctorRegisterStepStatus.APPROVED_DIRECTOR]: 'Aprovado'
}

export function translateDoctorRegisterStepStatusForDirector(
  status: DoctorRegisterStepStatus
) {
  switch (status) {
    case DoctorRegisterStepStatus.PENDENT:
      return 'Pendente'
    case DoctorRegisterStepStatus.APPROVED_DOCTOR_REGISTER:
      return 'Em análise'
    case DoctorRegisterStepStatus.REVIEW:
      return 'Revisão'
    case DoctorRegisterStepStatus.EMPTY:
      return 'Vazio'
    case DoctorRegisterStepStatus.UNDER_ANALYSIS:
      return 'Em análise'
    case DoctorRegisterStepStatus.CHANGED:
      return 'Alterado'
    case DoctorRegisterStepStatus.APPROVED_DIRECTOR:
      return 'Aprovado'
    default:
      return 'Pendente'
  }
}

export function translateDoctorRegisterStepStatusforHospital(
  status: DoctorRegisterStepStatus
) {
  switch (status) {
    case DoctorRegisterStepStatus.PENDENT:
      return 'Pendente'
    case DoctorRegisterStepStatus.APPROVED_DOCTOR_REGISTER:
      return 'Aprovado'
    case DoctorRegisterStepStatus.REVIEW:
      return 'Revisão'
    case DoctorRegisterStepStatus.EMPTY:
      return 'Vazio'
    case DoctorRegisterStepStatus.UNDER_ANALYSIS:
      return 'Em análise'
    case DoctorRegisterStepStatus.CHANGED:
      return 'Alterado'
    case DoctorRegisterStepStatus.APPROVED_DIRECTOR:
      return 'Aprovado pelo diretor'
  }
}
